import { render, staticRenderFns } from "./instagramIcon.vue?vue&type=template&id=c081fbc8&scoped=true"
import script from "./instagramIcon.vue?vue&type=script&lang=js"
export * from "./instagramIcon.vue?vue&type=script&lang=js"
import style0 from "./instagramIcon.vue?vue&type=style&index=0&id=c081fbc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c081fbc8",
  null
  
)

export default component.exports